export const Decode = (byteData: any) => {
  if (typeof byteData === "string") {
    return byteData
  }
  let res = ""
  for(let i = 0; i < byteData.length; i++) {
    res += String.fromCharCode(byteData[i]);
  }
  return res
}